// Admin i18n Context and Hook
import React, { createContext, useContext, useState, useEffect } from 'react';
import { en } from './en';
import { zh } from './zh';
import { de } from './de';

const translations = { en, zh, de };

const AdminI18nContext = createContext();

export const AdminI18nProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    // Load saved language preference
    const saved = localStorage.getItem('admin_language');
    if (saved && translations[saved]) {
      setLanguage(saved);
    }
  }, []);

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
      localStorage.setItem('admin_language', lang);
    }
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <AdminI18nContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </AdminI18nContext.Provider>
  );
};

export const useAdminTranslation = () => {
  const context = useContext(AdminI18nContext);
  if (!context) {
    throw new Error('useAdminTranslation must be used within AdminI18nProvider');
  }
  return context;
};
